class LocalStorageUtil {
    constructor() {
        const _prefix = process.env.REACT_APP_PREFIX;
        this.prefix = (_prefix? _prefix : '') +  '_';
    }
    setItem(key, value) {
        localStorage.setItem(this.prefix+key, value);
    }
    getItem(key) {
        return localStorage.getItem(this.prefix+key);
    }
    removeItem(key) {
        localStorage.removeItem(this.prefix+key);
    }
}

export default (() => {
    const ls = new LocalStorageUtil();
    return ls;
})();
